export enum RouteAuthValidationActionType {
  Decode = '@quidproquo-webserver/RouteAuthValidation/Decode',
}
